import React, {useState} from 'react';
import Error from "../../fragments/form/Error"
import Message from "../../fragments/form/Message"

import TextValue from "../../fragments/table/TextValue"
import {Link, useParams} from "react-router-dom";

function StateTable (props) {
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);
    const {countryId} = useParams();

    return(
        <div>
            <Error message={error} />
            <Message message={message} />
            <table>
                <tbody>
                    <tr>
                        <th>ID</th>
                        <th>NAME</th>
                        <th>STATUS</th>
                        <th>ACTIONS</th>
                    </tr>
                    {props.states.map((state, index) => (
                        <tr key={index}>
                            <td><TextValue value={state.id} /></td>
                            <td><TextValue value={state.state} /></td>
                            <td><TextValue value={state.is_published ? 'Published': 'Pending'} /></td>
                            <td>
                                <span>
                                    <Link to={`/country/${countryId}/state/${state.id}/municipalities`}>
                                        <i className="bi">View</i>
                                    </Link>
                                    <br />
                                    <Link to={`/country/${countryId}/state/${state.id}/edit`}>
                                        <i className="bi bi-pen">Edit</i>
                                    </Link>
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default StateTable;